import React, { useEffect, useState } from "react";
import { Outlet, useNavigate } from "react-router-dom";
import Sidebar from "./Sidebar";
import Header from "./Header";
import api from "@/lib/api";
import { useAuth } from "@/context/AuthContext";
import { Toaster } from "sonner";

export const FyContext = React.createContext({ fy: new Date().getFullYear(), setFy: () => {} });
export const AppNameContext = React.createContext("SAMS");

export default function AppShell() {
  const { user, checking } = useAuth();
  const nav = useNavigate();
  const [collapsed, setCollapsed] = useState(false);
  const [fy, setFy] = useState(() => {
    const d = new Date();
    return d.getMonth() >= 3 ? d.getFullYear() : d.getFullYear() - 1;
  });
  const [appName, setAppName] = useState("SAMS");

  useEffect(() => {
    if (!checking && !user) nav("/login");
  }, [user, checking, nav]);

  useEffect(() => {
    (async () => {
      try {
        const { data } = await api.get("/settings");
        if (data?.app_name) setAppName(data.app_name);
        document.title = `${data?.app_name || "SAMS"} | Supplier Audit Management System`;
      } catch { /* ignore */ }
    })();
  }, [user]);

  if (checking || !user) return <div className="h-screen grid place-items-center text-slate-500">Loading...</div>;

  return (
    <AppNameContext.Provider value={appName}>
      <FyContext.Provider value={{ fy, setFy }}>
        <div className="flex h-screen w-full overflow-hidden bg-[#F8FAFC]">
          <Sidebar collapsed={collapsed} onToggle={() => setCollapsed((v) => !v)} appName={appName} />
          <div className="flex-1 flex flex-col overflow-hidden">
            <Header appName={appName} fy={fy} setFy={setFy} />
            <main className="flex-1 overflow-y-auto p-6 lg:p-8 animate-fade-in">
              <Outlet />
            </main>
          </div>
          <Toaster position="top-right" richColors />
        </div>
      </FyContext.Provider>
    </AppNameContext.Provider>
  );
}
